module.exports = "\n/**\n * Let's put some structure into that text.\n */\n\n.md {\n  font-family: \"Helvetica Neue\", Helvetica, sans-serif;\n}\n\n.md h1, .md h2, .md h3, .md h4, .md h5, .md h6 {\n  display: inline-block;\n  color: #ddd;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 5px;\n}\n\n.md li {\n  margin: 5px 0;\n}\n\n.md h1, .md h2, .md h3, .md h4, .md h5, .md h6, .md ul, .md p {\n  margin: 0px;\n}\n\n/**\n * That's better. There you've got some general info.\n *\n * I'm also gonna write something about my interests... hold on.\n */\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./styles2.css
 ** module id = 85
 ** module chunks = 0 1
 **/